import React, { useEffect, useMemo, useRef, useState } from 'react'
import { RouteComponentProps, useHistory, useParams } from 'react-router-dom'
import { InitialStateUIType, InitialStateUserType } from '../../typings/state'
import {useQuery} from "react-query";
import { connect, useDispatch } from 'react-redux'
import './course-detail.scss'
import { LOADING_UI, UNLOADING_UI } from '../../redux/types'
import { CourseDetailTop } from './partials/course-detail-top'
import CourseMembers from '../../components/Layout/Course/CourseMembers'
import CourseRatings from '../../components/Layout/Course/CourseRatings'
import TabContentMaterial from './partials/tab-content-material'
import CourseDetailBottom from './partials/course-detail-bottom'
import {authenticatedRequestRaw} from "../../services/api.service";
import { CourseDetail as CourseDetailType } from "../../typings/course";
import TabContentAbout from "./partials/tab-content-about";
import dayjs from "dayjs";
import ReactStars from 'react-stars'
import Modal from "../../components/UI/Modal";
import Button from "../../components/UI/Button";
import {toast} from 'react-toastify'
import { Book, Calendar } from "lucide-react";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "../../components/UI/Tabs";
import { useBreadcrumbSetter } from '../../hooks/useBreadcrumbSetter'
import CourseTabs from "../../components/Layout/Course/CourseTabs";


interface CourseDetailProps extends RouteComponentProps{
  user: InitialStateUserType;
  UI: InitialStateUIType;
}
const CourseDetail: React.FC<CourseDetailProps> = (props) => {
  const ratingDesc = useRef('')
  const history  = useHistory();
  const dispatch = useDispatch();
  const params:any  = useParams();
  const [courseId, setCourseId] = useState<number | null>(null);
  const [course, setCourse] = useState<CourseDetailType | null>(null);
  const [showModalRating, setShowModalRating] = useState<boolean>(false)
  const [rating, setRating] = useState<number>(0)
  const [errorValidationRating, setErrorValidationRating] = useState<boolean>(false)
  const { data, refetch, isFetching } = useQuery('courseDetail', async () => {
    const response = await authenticatedRequestRaw('GET','/course/' + courseId)
    return response?.data?.data
  }, {enabled: false})
  const breadcrumbs = useMemo(() => [
      { label: "Belajar", path: "/course" },
      { label: course?.name || '-', isLast: true },
    ], [course]);
  const tabRef = useRef<any>(null);
  useBreadcrumbSetter(breadcrumbs);
  useEffect(() => {
    if(isNaN(params?.id)){
      history.push('/dashboard')
    }
    setCourseId(Number(params?.id));
  },[]) // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if(courseId){
      refetch();
    }
  },[courseId]);
  useEffect(() => {
    if(data){
      setCourse(data)
    }
  },[data]);
  useEffect(() => {
    if(course){
      if(course.isCompleted && course?.review === null){
        setShowModalRating(true)
      }
    }
  },[course]);
  useEffect(() => {
    if(isFetching){
      dispatch({ type: LOADING_UI })
    }else{
      dispatch({ type: UNLOADING_UI })
    }
  },[isFetching, dispatch])
  const getDurationDays = () => {
    if(course){
      const start = dayjs(course.start_date);
      const end = dayjs(course.end_date);
      return end.diff(start, 'days')+' Hari'
    }
    return ''
  }
  const submitRating = async () => {
    if(rating > 0){
      setShowModalRating(false)
      dispatch({ type: LOADING_UI })
      await authenticatedRequestRaw('POST','/course/submitRating',{
        course_id: course?.id,
        rate: rating,
        description: ratingDesc.current,
      })
      dispatch({ type: UNLOADING_UI })
      toast.success("Berhasil mengirim ulasan", {
        position: toast.POSITION.TOP_CENTER
      });
      refetch();
    }else{
      setErrorValidationRating(true);
    }
  }
  const getRating = (rating: number): number => {
    if(course?.totalReviews){
      return Number((rating / course?.totalReviews).toFixed(1))
    }
    return 0
  }
  return (
    <>
      <div className={"cd-container cd-with-bottom"}>
        <CourseDetailTop
          courseImage={course?.logo}
          courseName={course?.name}
          organization={course?.organization?.name}
        />
        <div className="cd-content">
          <h1 className="font-bold mb-2 text-xl">{course?.name}</h1>
          {course && (
            <span className={"fs-7 text-muted mb-3"}>{`${dayjs(
              data.start_date
            ).format("LL")} - ${dayjs(data.end_date).format("LL")}`}</span>
          )}
          <div className="mb-4 flex justify-between">
            <CourseMembers
              members={course?.courseMembers || []}
              totalMembers={course?.courseMembers?.length || 0}
            />
            {courseId && (
              <CourseRatings
                rating={getRating(course?.rating || 0)}
                totalReviews={course?.totalReviews || 0}
                courseId={courseId}
              />
            )}
          </div>
          <div className="flex w-full items-center justify-between cd-content-info pb-2 mb-2 border-b">
            <span className="inline-block px-2 py-1 text-xs font-medium rounded course-category-label mr-3">
              {course?.category?.name}
            </span>
            <span className="mr-3 flex items-center">
              <Book size="0.875rem" className="mr-1" />
              {course?.totalActivities} Materi
            </span>
            <span className="mr-3 flex items-center">
              <Calendar size="0.875rem" className="mr-1" /> {getDurationDays()}
            </span>
          </div>
          {course && <CourseTabs course={course} />}
        </div>
      </div>
      {course && course?.isJoined === false && (
        <CourseDetailBottom course={course} />
      )}
      <Modal
        show={showModalRating}
        onHide={() => {
          setShowModalRating(false);
        }}
        centered={true}
      >
        <Modal.Header>
          <Modal.Title>Ulasan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex flex-col">
            <p>
              Anda telah menyelesaikan kursus ini. Silahkan memberikan rating
              pada kursus ini
            </p>
            <div className="w-full">
              <ReactStars
                value={rating}
                count={5}
                onChange={(rate) => {
                  setRating(rate);
                }}
                size={48}
                color2={"#ffd700"}
                half={false}
              />
            </div>
            {errorValidationRating && (
              <p className="text-red-600 fs-7 italic mt-0">
                Rating tidak boleh kosong
              </p>
            )}
            <textarea
              className="form-control"
              placeholder="Tulis ulasan...."
              rows={5}
              onChange={(event) => (ratingDesc.current = event.target.value)}
            ></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            secondary
            onClick={() => {
              setShowModalRating(false);
            }}
          >
            Nanti Saja
          </Button>
          <Button primary className={"min-w-75px"} onClick={submitRating}>
            Kirim
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    UI: state.UI,
  };
};
export default connect(mapStateToProps,null)(CourseDetail);
